var cov_1b6972ycmu = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/validate/regExp.ts",
      hash = "abbfe2574fcdc2ef686abd17f6301a51cc38e420",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/validate/regExp.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 31
        }
      },
      "2": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 7,
          column: 72
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 11,
          column: 5
        }
      },
      "4": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 34
        }
      },
      "5": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 12
        }
      },
      "6": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 37
        }
      },
      "7": {
        start: {
          line: 12,
          column: 20
        },
        end: {
          line: 12,
          column: 37
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "9": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 20
        }
      },
      "10": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 18,
            column: 4
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 4,
            column: 11
          },
          end: {
            line: 4,
            column: 12
          }
        },
        loc: {
          start: {
            line: 4,
            column: 87
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 4
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 63
          }
        }, {
          start: {
            line: 7,
            column: 66
          },
          end: {
            line: 7,
            column: 72
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 37
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 37
          }
        }],
        line: 12
      },
      "3": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }],
        line: 13
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import nullable from './nullable';
export default (function (regExp, options) {
  cov_1b6972ycmu.f[0]++;
  cov_1b6972ycmu.s[0]++;
  return nullable(function (value, _formdata, callback) {
    cov_1b6972ycmu.f[1]++;

    var _ref = (cov_1b6972ycmu.s[1]++, options),
        message = _ref.message;

    var reg = (cov_1b6972ycmu.s[2]++, typeof regExp === 'string' ? (cov_1b6972ycmu.b[0][0]++, new RegExp(regExp)) : (cov_1b6972ycmu.b[0][1]++, regExp));
    cov_1b6972ycmu.s[3]++;

    if (!reg) {
      cov_1b6972ycmu.b[1][0]++;
      cov_1b6972ycmu.s[4]++;
      callback(new Error(message));
      cov_1b6972ycmu.s[5]++;
      return;
    } else {
      cov_1b6972ycmu.b[1][1]++;
    }

    cov_1b6972ycmu.s[6]++;

    if (reg.global) {
      cov_1b6972ycmu.b[2][0]++;
      cov_1b6972ycmu.s[7]++;
      reg.lastIndex = 0;
    } else {
      cov_1b6972ycmu.b[2][1]++;
    }

    cov_1b6972ycmu.s[8]++;

    if (reg.test(value)) {
      cov_1b6972ycmu.b[3][0]++;
      cov_1b6972ycmu.s[9]++;
      callback(true);
    } else {
      cov_1b6972ycmu.b[3][1]++;
      cov_1b6972ycmu.s[10]++;
      callback(new Error(message));
    }
  });
});